// Symbol label → prefix used to build the default `Nombre` (e.g. FDE-0001).
// Add new entries here whenever you introduce a new symbol/inspector and need a specific nomenclature.
export const FamilyPrefixMapping = {
    
  // Protección y Conmutación
  "Fuse": "FUS",                     // Fusible (IEC: F)
  "ElectromagneticSwitch": "PCSC",   // Contactores o protección sobrecorriente (IEC: Q)
  "OverloadRelay": "REL",            // Relé térmico o sobrecarga (IEC: K)
  "ElectronicRelay": "ERL",          // Relé electrónico (IEC: K)
  "Restaurateur": "REST",            // Restaurador

  // Alimentación y Transformación
  "ElectricEnergySupplier": "FAC",   // Fuente o acometida principal
  "TwoWindingTransformer": "TRA",    // Transformador de 2 devanados
  "ThreeWindingTransformer": "TR3",  // Transformador de 3 devanados

  // Generación y Conversión
  "Generator": "GEN",                // Generador eléctrico
  "PhotovoltaicGenerator": "PVG",    // Generador fotovoltaico (panel solar)
  "Vfd": "VFD",                      // Variador de frecuencia / inversor
  "SoftStarter": "SST",              // Arrancador suave
  "Ups": "UPS",                      // Sistema de alimentación ininterrumpida (UPS)

  // Distribución y Conductores
  "DistributionBoard": "DB",         // Tablero de distribución
  "Bus": "BUS",                      // Barra o busbar (IEC: U)
  "BusMononodo": "BUS",              // Barra o busbar de un nodo
  "Cable": "CAB",                    // Cable o conductor (IEC: W)
  "LightningContactChargingCenter": "MED", // Centro de medición o acometida
  "Box": "DESIGN",                   // Elemento de diseño
  "StraightLine": "DESIGN",          // Elemento de diseño
  "SymbolDrawer": "DESIGN",          // Elemento de diseño

  // Electrónica de potencia y control
  "ElectronicSwitch": "ELS",         // Interruptor electrónico
  "PowerSwitch": "SWP"               // Interruptor de potencia / seccionador
};
